var _line, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGitBranch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "lucide lucide-git-branch"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 6,
  x2: 6,
  y1: 3,
  y2: 15
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 6,
  r: 3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 18,
  r: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 9a9 9 0 0 1-9 9"
})));
export default SvgGitBranch;